export default {
    STATUSES: {
        RESERVED: 'RESERVED',
        PROCESSED: 'PROCESSED',
        NEW: 'NEW',
        DELETED: 'DELETED',
        EXPIRED: 'EXPIRED',
        PAID: 'PAID',
        VOID: 'VOID',
        FAILED: 'FAILED',
    },
};
